export interface CartAddition {
  productName: string;
  source:
    | 'search_bar'
    | 'recommendations'
    | 'search_page'
    | 'frequently_bought_together'
    | 'frequently_bought_together_modal';
  // Optional metadata for recommendations
  pageType?: string;
  recommendationType?: string;
}

interface CartTrackingData {
  data: CartAddition[];
  timestamp: number;
}

const CART_TRACKING_KEY = 'alfinder_cart_additions';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

const getCartAdditions = (): CartAddition[] => {
  const existingData = localStorage.getItem(CART_TRACKING_KEY);
  if (!existingData) {
    return [];
  }

  try {
    const parsedData: CartTrackingData = JSON.parse(existingData);
    const now = Date.now();

    // Check if data is expired (older than 1 week)
    if (now - parsedData.timestamp > ONE_WEEK_MS) {
      localStorage.removeItem(CART_TRACKING_KEY);
      return [];
    }

    return parsedData.data;
  } catch (error) {
    // If parsing fails, remove corrupted data
    localStorage.removeItem(CART_TRACKING_KEY);
    return [];
  }
};

export const addToCartTracking = (
  productName: string,
  source: CartAddition['source'],
  metadata?: { pageType?: string; recommendationType?: string },
) => {
  const cartAdditions = getCartAdditions();
  cartAdditions.push({
    productName,
    source,
    ...(metadata?.pageType && { pageType: metadata.pageType }),
    ...(metadata?.recommendationType && {
      recommendationType: metadata.recommendationType,
    }),
  });

  const dataToStore: CartTrackingData = {
    data: cartAdditions,
    timestamp: Date.now(),
  };

  localStorage.setItem(CART_TRACKING_KEY, JSON.stringify(dataToStore));
};

export const getCartTrackingData = (): CartAddition[] => {
  return getCartAdditions();
};

export const clearCartTracking = (): void => {
  localStorage.removeItem(CART_TRACKING_KEY);
};
